import serviceShape4 from "../../images/services/service-shape4.png"
import { Link } from "react-router-dom"
import { useLocation } from "react-router-dom"
import DynamicImage from "./DynamicImage";

const SolutionsCard = ({ data }) => {
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    return (
        <>
            {data.solutionCard?.map((card) => (
                <div className="col-lg-4 col-md-6 col-sm-12" key={card.id} data-aos="fade-up" data-aos-duration="1200">
                    <div className="single-services-item">
                        <div className="icon">
                            <DynamicImage image={card.image} />
                        </div>
                        <h3>
                            {card.header_menu?.page?.slug ? (
                                <Link to={`${card.header_menu?.parent?.slug}/${card.header_menu?.page?.slug}`}>
                                    {card.title}
                                </Link>
                            ) : (
                                card?.title || card.title
                            )
                            }
                        </h3>

                        <p>
                            {card.description}
                        </p>
                        {isHomePage && (
                            card.header_menu?.page?.slug ? (
                                <Link to={`${card.header_menu?.parent?.slug}/${card.header_menu?.page?.slug}`} className="default-btn">
                                    <i className="flaticon-right"></i>
                                    Learn More <span className="default-btn-hover"></span>
                                </Link>
                            ) : (
                                <Link to="#" onClick={(e) => e.preventDefault()} className="default-btn">
                                    <i className="flaticon-right"></i>
                                    Learn More <span className="default-btn-hover"></span>
                                </Link>
                            )
                        )}
                        <div className="shape1">
                            <img src={serviceShape4} alt="services" />
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default SolutionsCard
